import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 446,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  padding: '21px'
};
export default function Fallback({ error, resetErrorBoundary }) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.
  return (
    <div role="alert">
      <Modal
      className="welcome-modal"
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
         <div className="text-center mb-3">
         <Typography id="modal-modal-title" variant="h6" component="h2">
          Something went wrong!
          </Typography>
         </div>
          <div className="text-center mt-2">
          <Button className="submit-button" onClick={()=>{window.location.href="/dashboard"}}>Go to Dashboard</Button>
            </div>
 
        </Box>
      </Modal>
    </div>
  );
}